import React, { useEffect, useState, useContext } from 'react'
import {useParams, Link} from 'react-router-dom'
import Axios from 'axios'

import Loader from '../Loader/Loader'
import StateContext from '../../StateContext'
import FavoriteBlogPost from './FavoriteBlogPost'
import RateRecipe from './RateRecipe'
import { firestore } from '../../firebase'
import Instructions from './PostComponents/Instructions'
import Ingredients from './PostComponents/Ingredients'
import Categories from './PostComponents/Categories'
import { dateFormatter } from '../../helpers/dateFormatter'


function SinglePost() {

    const {id} = useParams()

    const appState = useContext(StateContext)

    const [isLoading, setIsloading] = useState(true);
    const [post, setPost] = useState([]);

    const [deleted, setDeleted] = useState(false);

    useEffect(() => {

        async function getBlogPost() {

            setIsloading(true)
            
            try {

                const postRef = firestore.collection("recipes").doc(id);
                postRef.onSnapshot(doc => {
                    const post = {id: doc.id, ...doc.data()}
                    setPost(post)
                })
                
            } catch (error) {

            }
            setIsloading(false)
        }
        getBlogPost()
    }, [id])

    
    

    if (isLoading) return  (
    
        <div className="text-center">
            <Loader />
        </div>

    )

    if (deleted) return <div className="col-md-6 mx-auto my-4"><div className="card card-body">Slettet!</div></div>

    return (
        <>
            <div className="container">            
                <div className="">  
                    <div className="col-lg-8 mx-auto mb-4 mt-1">

                        <div>

                            <div>

                                <h2 style={{fontSize: "2.8rem"}} className="font-weight-bold text-center mt-3">{post.title}</h2>
                                <img src={post.imageUrl || "https://camillahardilla.com/wp-content/uploads/2019/04/img_8219-1024x683.jpg"} className="img-fluid" />
                                <hr/>
                                <p>Av <Link to={`/member/${post.author_id}`}>{post.author_name}</Link> den {post.date && dateFormatter(post.date.toDate())} </p>
                                <hr />
                                    <RateRecipe recipeId={id} />
                                <hr/>

                                <p style={{fontSize: "1.3rem"}}>{post.description}</p>
                                <hr/>

                                <div className="row justify-content-center my-3">                      
                                    <div className="">
                                        <span className="text-center">
                                            {post.portions ? post.portions : "0"} portions  |  
                                            <span className="ml-2">{post.diet ? post.diet : "No description"}</span>  |  
                                            
                                        </span></div>                              
                                </div>
                            </div>
                      
                            <div className="row no-gutters">
   
                                <div className="col-6" style={{marginLeft: "-2px"}}>
                                    <FavoriteBlogPost recipeId={id} recipe={post} />
                                </div>

                                <div className="col-6">
                                    <div className="float-right">
                                        {appState.loggedIn && appState.userId === post.author_id && (
                                            <span className="pt-2">
                                                <div className="row">
                                                    <Link to={`/edit-post/${id}`} className="text-primary mr-2" title="Edit"><i className="fas fa-edit"></i></Link>
                                                    
                                                </div>
                                            </span>   
                                        )}                           
                                    </div> 
                                </div>

                            </div>  

                        </div>


                        <div className="row">
                            <div className="col-12">
                        
                                <div className="row my-2">

                                    <div className="col-2">
                                        <i className="fas fa-utensils"></i> <span className="font-weight-bold"></span>                                  
                                    </div>  

                                    <div className="col-10">
                                            
                                        <div className="row ">
                                            <Categories recipeId={id} />
                                        </div>
                                    </div>   

                                </div>
                                    
                                
                                <div className="row my-2">
                                    <div className="col-2">
                                        <i className="fas fa-stopwatch"></i> <span className="font-weight-bold"></span> 
                                    </div>     
                                    <div className="col-10">        
                                        <div className="float-left">{+post.preparation_time} min</div>
                                    </div>               
                                </div>

                            </div>
                        </div>

                        <hr />

                        <div className="row">
                            <div className="col-lg-4">
                                <h6 className="font-weight-bold mt-4"><i className="fas fa-pizza-slice"></i> Ingredients</h6>
                        
                                <Ingredients recipeId={id} />
                            </div>
                            <div className="col-lg-8">
                                <h6 className="font-weight-bold mt-4"><i className="fas fa-mortar-pestle"></i> Instructions</h6>
                                                            
                                <Instructions recipeId={id} />  
                            </div>
                        </div>
                        <hr/>
                        



                    </div>
         
                    
                    
                </div>

                 
            </div>   
        </>
    )
}
export default SinglePost